import { Component, EventEmitter, Input, Output } from '@angular/core';
import { markdown } from '@saliente/library';
import { ZoneFeature } from './release-notes.service';

@Component({
    selector: 'app-release-notes-dialog',
    templateUrl: './release-notes-dialog.component.html',
    styleUrls: ['./release-notes-dialog.component.scss'],
    standalone: false
})
export class ReleaseNotesDialogComponent {
  @Input() public features: ZoneFeature[] = [];
  @Input() public visible: boolean = false;
  @Output() public close = new EventEmitter<void>();

  public currentFeatureIndex: number = 0;

  /**
   * Get the currently displayed feature
   */
  public getCurrentFeature(): ZoneFeature | null {
    return this.features && this.features.length > 0
      ? this.features[this.currentFeatureIndex]
      : null;
  }

  /**
   * Navigate to the next feature
   */
  public nextFeature(): void {
    if (this.canGoNext()) {
      this.currentFeatureIndex++;
    }
  }

  /**
   * Navigate to the previous feature
   */
  public prevFeature(): void {
    if (this.canGoPrev()) {
      this.currentFeatureIndex--;
    }
  }

  /**
   * Check if can navigate to previous feature
   */
  public canGoPrev(): boolean {
    return this.currentFeatureIndex > 0;
  }

  /**
   * Check if can navigate to next feature
   */
  public canGoNext(): boolean {
    return this.currentFeatureIndex < this.features.length - 1;
  }

  /**
   * Get the total number of features
   */
  public getTotalFeatures(): number {
    return this.features ? this.features.length : 0;
  }

  /**
   * Get the current feature number (1-indexed)
   */
  public getCurrentFeatureNumber(): number {
    return this.currentFeatureIndex + 1;
  }

  /**
   * Check if currently on the first feature
   */
  public isFirstFeature(): boolean {
    return this.currentFeatureIndex === 0;
  }

  /**
   * Check if currently on the last feature
   */
  public isLastFeature(): boolean {
    return this.currentFeatureIndex === this.features.length - 1;
  }

  /**
   * Render markdown content as HTML
   * @param content Markdown string
   * @returns HTML string
   */
  public renderMarkdown(content: string): string {
    return markdown(content);
  }

  /**
   * Handle dialog close event (skip tour)
   */
  public onClose(): void {
    this.close.emit();
  }
}
